import _ from 'lodash';
import { VehicleFilterDTO, VehicleStateEnum } from 'src/api';
import type { ReactSelectOption } from 'src/types';
import type * as MT from '../motornet/types';

export type VehicleSelectOpt = ReactSelectOption & {
	vehicle: VehicleFilterDTO;
	subtitle: string;
};

/** Quante opzioni mostrare nel menu a tendina. */
export const VEHICLE_SEARCH_PAGE_SIZE = 25;
const DEBOUNCE_MS = 400;

export const toVehicleSelectOpt = (vehicle: any): VehicleSelectOpt => ({
	label: `${vehicle.marca} ${vehicle.modello || ''}`,
	value: `${vehicle.id} ${vehicle.codice_costruttore} ${vehicle.nr_ordine}`,
	subtitle: `Ord. Commerciale: ${vehicle.nr_ordine}`,
	vehicle,
});

type GetPage = (
	params: MT.PlatformVehiclesRequest
) => Promise<MT.PlatformVehiclesResponse>;

export const searchVehicles = async (
	getPage: GetPage,
	query: string,
	extraParams: Partial<MT.PlatformVehiclesRequest> = {}
): Promise<VehicleSelectOpt[]> => {
	const search = (query ?? '').trim();

	if (!search) return [];

	const res = await getPage({
		search,
		stato_corrente: [VehicleStateEnum.DISPONIBILE],
		normalize: true,
		pageSize: VEHICLE_SEARCH_PAGE_SIZE,
		...extraParams,
	});

	return res.items.map(toVehicleSelectOpt);
};

export const createVehicleSearch = (
	getPage: GetPage,
	extraParams: Partial<MT.PlatformVehiclesRequest> = {}
) =>
	_.debounce((query: string, cb: (opts: VehicleSelectOpt[]) => void) => {
		searchVehicles(getPage, query, extraParams)
			.then(cb)
			.catch((err) => {
				console.warn('[vehicleSearch]', err);
				cb([]);
			});
	}, DEBOUNCE_MS);
